import { bodyBgGradient1 } from './BodyBgStore';

import { bodyBgGradient1Default } from './BodyBgStoreDefaults';

export const resetBodyBgGradient1 = () => bodyBgGradient1.set(bodyBgGradient1Default);
